import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getApellidosOperarios`, method: 'GET', body: null, token: token})
}